import Box from "@mui/joy/Box";
import Stack from "@mui/joy/Stack";
import Post from "Post";
import { useGetAllPublishedPostsQuery } from "services/post/postApi";


const Posts = () => {
  const { data, isLoading, error } = useGetAllPublishedPostsQuery({});

  if (isLoading) {
    return null;
  }

  if (!data) {
    return null;
  }

  return(
    <Box  minWidth='320px' maxWidth='1024px' m='0 auto' paddingTop={2}>
      <Stack spacing={ 2 }>
        { 
        Array.from(data.map(post => <Post slug id={post.id} key={post.id} />))
        }
      </Stack>
    </Box>
  )
};

export default Posts;